import { BasePriceBreakdown } from "../../components";

export const CORE_CARS_NAME = "core-cars";

export enum CoreCarsComponent {
  CarSearch = "CarSearch",
  SearchPage = "SearchPage",
  AvailabilityPage = "AvailabilityPage",
  CarList = "CarList",
  CarListHeader = "CarListHeader",
  CarListNoResult = "CarListNoResult",
  CarListLoading = "CarListLoading",
  CarCard = "CarCard",
  CarCardPrice = "CarCardPrice",
  CarSpecificationsSummary = "CarSpecificationsSummary",
  CarSpecificationsDialog = "CarSpecificationsDialog",
  CarAvailabilityMap = "CarAvailabilityMap",
  CarAvailabilityHeader = "CarAvailabilityHeader",
  CarAvailabilityHeaderContent = "CarAvailabilityHeaderContent",
  CarAvailabilityFilterRow = "CarAvailabilityFilterRow",
  CarAvailabilityMapRedoSearchButton = "CarAvailabilityMapRedoSearchButton",
  CarListSort = "CarListSort",
  FilterDialog = "FilterDialog",
  PriceBreakdownDialog = "PriceBreakdownDialog",
  CarListStoreGroup = "CarListStoreGroup",
  StoreCardHeader = "StoreCardHeader",
  StoreMapMarker = "StoreMapMarker",
  LocationPreviewDialog = "LocationPreviewDialog",
  CarReservationCard = "CarReservationCard",
  CarReservationDetailTitle = "CarReservationDetailTitle",
  CarReservationDetailPage = "CarReservationDetailPage",
  CarReservationConfirmation = "CarReservationConfirmation",
  CarReservationDetailSummary = "CarReservationDetailSummary",
  CarReservationDriverInfo = "CarReservationDriverInfo",
  CarReservationFuelInfo = "CarReservationFuelInfo",
  CarReservationLocation = "CarReservationLocation",
  CarReservationSelfServeLinks = "CarReservationSelfServeLinks",
  CarReservationCancelPolicy = "CarReservationCancelPolicy",
  CarReservationPayment = "CarReservationPayment",
  CarReservationPaymentContent = "CarReservationPaymentContent",
  CustomerSupportModalContent = "CustomerSupportModalContent",
  CustomerSupportModal = "CustomerSupportModal",
  ResendEmailModal = "ResendEmailModal",
  CancelCarModal = "CancelFlightModal",
  CarDescription = "CarDescription",
  CarTimeAndDateInfo = "CarTimeAndDateInfo",
  PaymentSummaryLineItem = "PaymentSummaryLineItem",
  ShopPage = "ShopPage",
  ShopHeader = "ShopHeader",
  ShopSearchEdit = "ShopSearchEdit",
  ShopTabs = "ShopTabs",
  ShopInfo = "ShopInfo",
  ShopInfoSection = "ShopInfoSection",
  ShopMap = "ShopMap",
  ShopVehicleList = "ShopVehicleList",
  EditCarSearch = "EditCarSearch",
  BasePriceBreakdown = "BasePriceBreakdown",
  ShopTabViewHeader = "ShopTabViewHeader",
  CarListError = "CarListError",
}
